export default "__VITE_PUBLIC_ASSET__19933b63__"